import { Button } from '@/shared/components'

type OnlineSessionConfirmationModalProps = {
  isOpen: boolean
  onContinue: () => void
}

export function OnlineSessionConfirmationModal({
  isOpen,
  onContinue
}: OnlineSessionConfirmationModalProps) {
  if (!isOpen) {
    return null
  }

  return (
    <div className="fixed inset-0 z-[2147483647] flex items-center justify-center bg-black/50 p-4">
      <div className="w-full max-w-lg rounded-2xl bg-white p-6 shadow-2xl">
        <h2 className="mb-3 text-xl font-bold text-gray-900">
          Great news, you&apos;re registered for the 160 Driving Academy Online Information
          Session!
        </h2>
        <p className="mb-6 text-sm leading-6 text-gray-600">
          We&apos;re excited to have you join us and learn more about how you can get on the road
          toward a new career.
        </p>
        <Button type="button" fullWidth onClick={onContinue}>
          Continue
        </Button>
      </div>
    </div>
  )
}
